import React from 'react';
import styles from './style.module.scss';

interface IProps {
    source: string[]
    style?: React.CSSProperties
}

const initStyle = {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '19px'
}

const Location: React.FC<IProps> = ({ source, style }) => {
    const mergedStyle: React.CSSProperties = {
        ...initStyle,
        ...style
    };
    return <div className={styles.location} title={source.join('')} style={mergedStyle}>
        {source.map((item, i) => <span key={i}>{item}</span>)}
    </div>;
};

export default Location;
